// Resolves a usable ISO 4217 currency code for API requests.
//
// Returns the first candidate that looks like a real code, uppercased, or null
// when none does. Guards against values serialized from unresolved state such
// as the literal strings "undefined" and "null" (TGF-1240).

const CURRENCY_CODE_PATTERN = /^[A-Za-z]{3}$/;
const SERIALIZED_EMPTY_VALUES = ['undefined', 'null'];

const toCurrencyCode = (candidate) => {
    if (typeof candidate !== 'string') return null;
    const value = candidate.trim();
    if (SERIALIZED_EMPTY_VALUES.includes(value.toLowerCase())) return null;
    if (!CURRENCY_CODE_PATTERN.test(value)) return null;
    return value.toUpperCase();
};

export const resolveCurrencyCode = (...candidates) => {
    for (const candidate of candidates) {
        const code = toCurrencyCode(candidate);
        if (code) return code;
    }
    return null;
};
